export const TEST_IDS = {
  SCHEDULE_BTN: 'schedule-btn',
  REJECT_BTN: 'reject-btn',
};
